import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import type { Person } from '@/types/leads';

export const usePersons = () => {
  return useQuery<Person[]>({
    queryKey: ['persons', 'list'],
    queryFn: async () => {
      const { data } = await api.get(API_ROUTES.persons, {
        params: { limit: 1000 },
      });
      return data.results || data;
    },
  });
};
